import { AddCircle, ArrowDown2, ArrowLeft2, ArrowRight, Clock, Danger, RecordCircle, SearchNormal1 } from "iconsax-react";
import { JOURNEY_OVERVIEW_STATUS, JourneyOverview } from "../../store/types/journeyControl";
import { formatCPF, formatSeconds } from "../../utils/functions/formatters";
import ExpandableDatatableBox from "./ExpandableDatatableBox";
import { useState } from "react";
import { motion } from 'framer-motion';
import Tippy from "@tippyjs/react";
import { Colors } from "../../utils/constants/style";
import RoundedFilledButton from "../RoundedFilledButton/RoundedFilledButton";

interface ExpandableDatatableCardProps {
  journeyOverviewItem: JourneyOverview;
}

const ExpandableDatatableCard: React.FC<ExpandableDatatableCardProps> = ({
  journeyOverviewItem,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
      setIsExpanded((prev) => !prev);
  };

  let borderColor = "";

  switch(journeyOverviewItem.status) {
    case JOURNEY_OVERVIEW_STATUS.OK :
      borderColor = "#4CAF50";
      break;

    case JOURNEY_OVERVIEW_STATUS.NOK :
      borderColor = "#DA1E27";
      break;

    case JOURNEY_OVERVIEW_STATUS.OK_WITH_PROBLEMS :
      borderColor = "#FB8C00";
      break;
  }

  return (
    <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.05 }}
            whileHover={{ backgroundColor: Colors.gray_0 }}
            className={`py-2 px-10 mb-3 w-full border-l-4 border-solid border-gray_0 border-2 rounded-lg hover:bg-gray_01 transition-all duration-300`}
            style={{ borderLeftWidth: '15px', borderLeftColor: borderColor }}
        >
          <motion.button
              onClick={toggleExpand}
              className="flex w-full"
            >
              <div className="flex gap-14">
                <div  className="text-start">
                  <p className="font-bold text-8 text-gray_2">Colaborador</p>
                  <p className="font-light text-10">{journeyOverviewItem.name}</p>
                </div>
                <div className="text-start">
                  <p className="font-bold text-8 text-gray_2">CPF</p>
                  <p className="font-light text-10">{formatCPF(journeyOverviewItem.cpf)}</p>
                </div>
                <div className="text-start">
                  <p className="font-bold text-8 text-gray_2">Veículo</p>
                  <p className="font-light text-10">{journeyOverviewItem.plate}</p>
                </div>
                <div className="text-start">
                  <p className="font-bold text-8 text-gray_2">Tempo de Jornada</p>
                  <p className="font-light text-10">{journeyOverviewItem.journey_time != null ? formatSeconds(journeyOverviewItem.journey_time) : "-"}</p>
                </div>
                <div className="text-start">
                  <p className="font-bold text-8 text-gray_2">Horas Extras</p>
                  <p className="font-light text-10">{journeyOverviewItem.extra_hours != null ? formatSeconds(journeyOverviewItem.extra_hours) : "-"}</p>
                </div>
              </div>
              <div className="flex items-center ml-auto">
                <div
                  onClick={() => console.log("123")}
                  className="cursor-pointer"
                >
                  <Tippy
                    content={"Ver jornada"}
                    className="px-2 py-1 bg-gray_3 text-sm rounded-md text-white font-medium"
                    duration={1}
                  >
                    <SearchNormal1 size="24" color={Colors.gray_2} variant="Linear" />
                  </Tippy>
                </div>
              </div>  
              
          </motion.button>
          
            <motion.div
                initial={false}
                animate={{ height: isExpanded ? "200px" : "0" }}
                transition={{
                    duration: 0.8,
                    ease: [0.25, 0.1, 0.25, 1],
                }}
                className={`overflow-hidden ${isExpanded ? "mt-2" : "mt-2"}`}
            >
              <div>
                <div className="flex gap-3 mt-4">
                  <ExpandableDatatableBox 
                    title="Trabalhadas"
                    events={journeyOverviewItem.worked_hours.events}
                    infractions={journeyOverviewItem.worked_hours.infractions}
                    time={journeyOverviewItem.worked_hours.time}
                    status={journeyOverviewItem.worked_hours.status}
                  />

                  <ExpandableDatatableBox 
                    title="Refeição"
                    events={journeyOverviewItem.meal.events}
                    infractions={journeyOverviewItem.meal.infractions}
                    time={journeyOverviewItem.meal.time}
                    status={journeyOverviewItem.meal.status}
                  />

                  <ExpandableDatatableBox 
                    title="Em espera"
                    events={journeyOverviewItem.waiting.events}
                    infractions={journeyOverviewItem.waiting.infractions}
                    time={journeyOverviewItem.waiting.time}
                    status={journeyOverviewItem.waiting.status}
                  />

                  <ExpandableDatatableBox 
                    title="À disposição"
                    events={journeyOverviewItem.free_time.events}
                    infractions={journeyOverviewItem.free_time.infractions}
                    time={journeyOverviewItem.free_time.time}
                    status={journeyOverviewItem.free_time.status}
                  />

                  <ExpandableDatatableBox 
                    title="Fim de jornada"
                    events={journeyOverviewItem.journey_end.events}
                    infractions={journeyOverviewItem.journey_end.infractions}
                    time={journeyOverviewItem.journey_end.time}
                    status={journeyOverviewItem.journey_end.status}
                  />
                </div>
              </div>
              
            </motion.div>
        </motion.div>
  )
};

export default ExpandableDatatableCard;
